<template>
    <v-container fluid>
        <v-row class="mt-12 mx-12">
            <v-col class="" cols="12">
                <v-card class="green lighten-4 pa-6 elevation-12">
                    <v-card-title class="display-2 text--primary justify-center font-weight-black"><p class="teal--text">중고차 목록</p></v-card-title>
                    <v-tabs
                        v-model="tab"
                        background-color="teal"
                        dark
                        grow
                      >
                        <v-tab>소형차</v-tab>
                        <v-tab>중형차</v-tab>
                        <v-tab>고급차</v-tab>
                        <v-tab>승합차/SUV</v-tab>
                    </v-tabs>
                    <v-card class="elevation-6">
                        <v-tabs-items v-model="tab">
                            <v-tab-item>
                                <v-row>
                                    <v-col class="pa-6" cols="3">
                                        <v-img class="mx-auto" src="../../assets/usedcar/hyundai_avante_md16.jpg" width="400"></v-img>
                                        <p class="title text-center">현대 아반떼 MD 1.6</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/hyundai_avante_new.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 현대 아반떼</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/kia_k3.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 KIA K3</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/kia_ray.jpg" width="400"></v-img>
                                        <p class="title text-center">KIA 레이</p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row>
                                    <v-col class="pa-6" cols="3">
                                        <v-img flex src="../../assets/usedcar/hyundai_sonata_cf.jpg" width="400"></v-img>
                                        <p class="title text-center">현대 CF 소나타</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/hyundai_sonata_new.png" width="400"></v-img>
                                        <p class="title text-center">신형 현대 소나타</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/kia_k5.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 KIA K5</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/rsm_sm6.jpg" width="400"></v-img>
                                        <p class="title text-center">RSM SM6</p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row>
                                    <v-col class="pa-6" cols="3">
                                        <v-img flex src="../../assets/usedcar/hyundai_grandeurig.jpg" width="400"></v-img>
                                        <p class="title text-center">현대 그랜져 IG</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/hyundai_grandeur_new.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 현대 그랜져</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/genesis_g80.jpg" width="400"></v-img>
                                        <p class="title text-center">Genesis G80</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/genesis_g90.png" width="400"></v-img>
                                        <p class="title text-center">Genesis G90</p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <v-tab-item>
                                <v-row>
                                    <v-col class="pa-6" cols="3">
                                        <v-img flex src="../../assets/usedcar/hyundai_palisade.jpg" width="400"></v-img>
                                        <p class="title text-center">현대 펠리세이드</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/hyundai_santafe.png" width="400"></v-img>
                                        <p class="title text-center">신형 현대 싼타페</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/kia_carnivan.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 KIA 카니반</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/hyundai_starex.jpg" width="400"></v-img>
                                        <p class="title text-center">신형 스타렉스</p>
                                    </v-col>
                                    <v-col class="pa-6" cols="3">
                                        <v-img src="../../assets/usedcar/kia_mohave.jpg" width="400"></v-img>
                                        <p class="title text-center">KIA 모하비</p>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-card>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
export default {
  name: "UsedcarTable",
  components: {
  },
  data: () => ({
      tab: null,
      tabItems: [
        '소형', '중형', '고급', '승합',
      ]
  }),
};
</script>
<style scoped>
</style>
